import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Box, Flex, HStack, Icon, Progress, Text } from '@chakra-ui/react';
import { VideoList, Video } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { gql } from '@src/lib/gql';
import { MdVideocam } from 'react-icons/md';
type VideoLessonProgressBarProps = {
  videoList: VideoList;
  video: Video;
};
export const VideoLessonProgressBar = props => {
  const $ = _c(15);
  const {
    currentUser
  } = useCurrentUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = gql`
      query ($viewableType: String, $viewableId: String) {
        scoView(viewableType: $viewableType, viewableId: $viewableId) {
          id
          viewableType
          viewableId
          startedAt
          completionAsPercent
          completedAt
        }
      }
    `;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !currentUser?.isRegistered;
  let t2;
  if ($[1] !== props.video.__typename || $[2] !== props.video.id) {
    t2 = {
      viewableType: props.video.__typename,
      viewableId: props.video.id
    };
    $[1] = props.video.__typename;
    $[2] = props.video.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      ssr: false,
      skip: t1,
      variables: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const viewQuery = useQuery(t0, t3);
  const completionAsPercent = viewQuery.data?.scoView?.completionAsPercent ?? 0;
  let t4;
  if ($[7] !== props.video.durationInSeconds) {
    t4 = props.video.durationInSeconds && <Flex alignItems="center" gap={1}><Icon asChild={true} boxSize={4} color="primary"><MdVideocam /></Icon><Text opacity="0.7" textStyle="labelXs">{Math.round(props.video.durationInSeconds / 60)}{"m "}{Math.round(props.video.durationInSeconds % 60)}s</Text></Flex>;
    $[7] = props.video.durationInSeconds;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Progress.Track><Progress.Range /></Progress.Track>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== completionAsPercent) {
    t6 = <Box flexGrow={1}><Progress.Root borderRadius="full" size="sm" value={completionAsPercent} variant="subtle">{t5}</Progress.Root></Box>;
    $[10] = completionAsPercent;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <HStack alignContent="flex-start" alignItems="center" gap="1em">{t4}{t6}</HStack>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
VideoLessonProgressBar.fragments = {
  Video: () => gql`
    fragment _ on Video {
      id
      durationInSeconds
    }
  `
};